import { api } from './api'
import type { TenantSettings } from '../types/tenantSettings'

export const tenantSettingsService = {
  /**
   * Get current tenant settings.
   */
  getCurrent: async (): Promise<TenantSettings> => {
    const response = await api.get<TenantSettings>('/tenant/settings')
    return response.data
  },

  /**
   * Update tenant settings.
   */
  update: async (data: Partial<TenantSettings>): Promise<TenantSettings> => {
    const response = await api.put<TenantSettings>('/tenant/settings', data)
    return response.data
  },
}

